/* eslint-disable import/no-unresolved */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Swiper as ReactSwiper, SwiperSlide as ReactSwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import {
  Keyboard, Pagination, Navigation, Mousewheel,
} from 'swiper/modules';

import { styled, Box } from '@mui/material';

import { swiperDefaultStyles } from './styles';

export const SwiperRaw = ({
  className, children, onSlideChange, ReactSwiperProps, navigationOutside = false,
}) => {
  const [lock, setLock] = useState(true);

  const handleChange = (a) => {
    onSlideChange?.(a);
  };

  const swiperWrapperClasses = {
    'dn-swiper-wrapper': true,
    'dn-swiper-footer-pagination': children.length > 1,
    'dn-navigation-outside': navigationOutside,
    'dn-swiper-lock': lock,
  };

  return (
    <Box className={className}>
      <Box className={swiperWrapperClasses}>
        <ReactSwiper
          className="sample-slider"
          onLock={(s) => setLock(s.isLocked)}
          onUnlock={(s) => setLock(s.isLocked)}
          onSlideChange={handleChange}
          slidesPerView={1}
          spaceBetween={0}
          speed={750}
          grabCursor
          autoHeight
          keyboard={{
            enabled: true,
          }}
          pagination={{
            dynamicBullets: true,
          }}
          navigation
          modules={[Keyboard, Pagination, Navigation, Mousewheel]}
          {...ReactSwiperProps}
        >
          {children}
        </ReactSwiper>
      </Box>
    </Box>
  );
};

SwiperRaw.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onSlideChange: PropTypes.func,
  navigationOutside: PropTypes.bool,
  ReactSwiperProps: PropTypes.object,
};

export const Swiper = styled(SwiperRaw)(swiperDefaultStyles);

export const SwiperSlide = ReactSwiperSlide;
